export function isPremiumColumnVisible(visibleColumnIds: string[]): boolean {
  return visibleColumnIds.includes('premium');
}

export function filterPricingRows<T extends { label?: string }>(
  rows: T[],
  showOfflineAccess: boolean,
): T[] {
  if (showOfflineAccess) return rows;
  return rows.filter(row => row.label !== 'Offline access');
}
